import {
	BreakpointWidth
} from '@app/enumerations';
import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	alpha,
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		loadingOverlay_body: {
			height: '100%',
			width: '100%',
			outline: 'none',
		},
		loadingOverlay_fixed: {
			position: 'fixed'
		},
		loadingOverlay_absolute: {
			top: 0,
			left: 0,
			position: 'absolute'
		},
		loadingOverlay_hidden: {
			display: 'none',
		},
		loadingOverlay_interior: {
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		loadingOverlay_logoWrapper: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
		},
		loadingOverlay_logo: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				width: '100px !important',
				height: '100px !important',
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				width: '75px !important',
				height: '75px !important',
			},
			'& > span': {
				[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
					width: '100px !important',
					height: '100px !important',
				},
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					width: '75px !important',
					height: '75px !important',
				},
				borderColor: `${theme.palette.primary.main} !important`,
			}
		},
		loadingOverlay_messages: {
			fontSize: '1.75em',
			marginTop: '20px',
			color: theme.palette.primary.main,
			display: 'flex',
			flexDirection: 'column',
		},
		loadingOverlay_message: {
			[theme.breakpoints.down(BreakpointWidth.MEDIUM)]: {
				fontSize: '.75em'
			},
			[theme.breakpoints.between(BreakpointWidth.MEDIUM, BreakpointWidth.LARGE)]: {
				fontSize: '.85em'
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: '1em',
			},
			color: 'inherit',
			margin: '10px',
			textAlign: 'center',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
		},
		loadingOverlay_dialog: {

		},
		loadingOverlay_dialogPaper: {
			boxShadow: 'none',
			background: 'transparent',
		},
		loadingOverlay_dialogBackdrop: {
			background: alpha(theme.palette.background.default, .9),
		},
		loadingOverlay_dialogExterior: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
		},
		loadingOverlay_defaultExterior: {
			position: 'absolute',
			top: 0,
			bottom: 0,
			left: 0,
			right: 0,
			background: alpha(theme.palette.background.default, .9),
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
		},
	});
});

export default useStyles;